module.exports = __webpack_public_path__ + "img/moea.176fda20.png";